export default __webpack_public_path__ + "static/media/portfolio.6b03b940.png";